// import { N07_02 } from "./N07_02";

import { N08_02 } from "./N08_02";

export const N08_01 = {
  selectedValueColumn: "Region",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "Field Supervisors",
        binding: {
          data: {
            columns: [
              {
                name: "FS Name",
                columnName: "FieldSupervisorName",
                width: "300px",
                align: "left",
                sortable: true,
              },
              {
                name: "District",
                columnName: "District",
                width: "550px",
                align: "left",
                sortable: true,
              },
              {
                name: "Coverage",
                columnName: "Coverage",
                width: "150px",
                align: "center",
                sortable: true,
              },
              {
                name: "Target",
                columnName: "Target",
                width: "150px",
                align: "center",
                sortable: true,
              },
              {
                name: "Coverage %",
                columnName: "CoveragePercent",
                width: "150px",
                align: "center",
                sortable: true,
                percent: true,
              },
              {
                name: "TER Team",
                columnName: "TERTeam",
                width: "150px",
                align: "center",
                sortable: true,
              },
              {
                name: "Working Days",
                columnName: "WorkingDays",
                width: "170px",
                align: "center",
                sortable: true,
              },
              {
                name: "Average Call",
                columnName: "AverageCall",
                width: "170px",
                align: "center",
                sortable: true,
              },
              {
                name: "Target Average Call",
                columnName: "TargetAverageCall",
                width: "200px",
                align: "center",
                sortable: true,
              },
              {
                name: "Actual Team Call",
                columnName: "ActualTeamCall",
                width: "170px",
                align: "center",
                sortable: true,
              },
              {
                name: "Target Team Call",
                columnName: "TargetTeamCall",
                width: "170px",
                align: "center",
                sortable: true,
              },
              {
                name: "Call Rate",
                columnName: "CallRate",
                width: "170px",
                align: "center",
                sortable: true,
                percent: true,
              },
            ],
            title: "District",
            endpoint: "N08.1",
            parameters: [
              { key: "FromMonth", value: "CP1" },
              { key: "FromYear", value: "2026" },
              { key: "ToMonth", value: "CP1" },
              { key: "ToYear", value: "2026" },
              { key: "Region", value: "" },
            ],
          },
          context: {
            point: {
              onClick: N08_02,
            },
          },
        },
      },
    },
  ],
};
